import {
  daDK as coreDaDK,
  deDE as coreDeDE,
  enUS as coreEnUS,
  esES as coreEsES,
  frFR as coreFrFR,
  itIT as coreItIT,
  nlNL as coreNlNL,
  plPL as corePlPL,
  roRO as coreRoRO,
  srRS as coreSrRS,
  svSE as coreSvSE,
  ukUA as coreUkUA,
} from "@mui/material/locale";
import {
  daDK,
  deDE,
  enUS,
  esES,
  frFR,
  itIT,
  nlNL,
  plPL,
  roRO,
  svSE,
  ukUA,
} from "@mui/x-data-grid-premium/locales";
import { LanguageMap } from "common/i18nConstants";
import { TFunction } from "i18next";

export const MUI_DATA_GRID_LANGUAGES = {
  "bs-Latn-BA": (t) => [
    {
      components: {
        MuiDataGrid: {
          defaultProps: {
            localeText: {
              footerTotalRows: t("components.DataGrid.totalRows"),
              toolbarExport: t("components.DataGrid.export"),
              toolbarExportLabel: t("components.DataGrid.export"),
              toolbarExportCSV: t("components.DataGrid.downloadAsCsv"),
              noRowsLabel: t("components.DataGrid.noRows"),
            },
          },
        },
      },
    },
    {},
  ], // MUI does not have a Bosnian locale
  "da-DK": (_) => [daDK, coreDaDK],
  "de-DE": (_) => [deDE, coreDeDE],
  "en-US": (_) => [enUS, coreEnUS],
  "es-ES": (_) => [esES, coreEsES],
  "fr-FR": (_) => [frFR, coreFrFR],
  "it-IT": (_) => [itIT, coreItIT],
  "lt-LT": (t) => [
    {
      components: {
        MuiDataGrid: {
          defaultProps: {
            localeText: {
              footerTotalRows: t("components.DataGrid.totalRows"),
              toolbarExport: t("components.DataGrid.export"),
              toolbarExportLabel: t("components.DataGrid.export"),
              toolbarExportCSV: t("components.DataGrid.downloadAsCsv"),
              noRowsLabel: t("components.DataGrid.noRows"),
            },
          },
        },
      },
    },
    {},
  ], // MUI does not have a Lithuanian locale
  "nl-NL": (_) => [nlNL, coreNlNL],
  "pl-PL": (_) => [plPL, corePlPL],
  "ro-RO": (_) => [roRO, coreRoRO],
  "sr-Latn-RS": (t) => [
    {
      components: {
        MuiDataGrid: {
          defaultProps: {
            localeText: {
              footerTotalRows: t("components.DataGrid.totalRows"),
              toolbarExport: t("components.DataGrid.export"),
              toolbarExportLabel: t("components.DataGrid.export"),
              toolbarExportCSV: t("components.DataGrid.downloadAsCsv"),
              noRowsLabel: t("components.DataGrid.noRows"),
            },
          },
        },
      },
    },
    coreSrRS,
  ], // MUI data grid premium does not have a Serbian locale
  "sv-SE": (_) => [svSE, coreSvSE],
  "uk-UA": (_) => [ukUA, coreUkUA],
} as const satisfies LanguageMap<
  (t: TFunction) => [typeof daDK, typeof coreDaDK]
>;
